/* eslint-disable valid-jsdoc */
/* global femcare, axios */

femcare.product.panel.info.shop = {
    $mainPanel: $('.product-main--shop'),
    $notificationModal: $('.modal--cart-notification'),
    $productMedia: null,
    mediaPanel: null,
    sku: null,
    selectedOptions: {},
    defaultShopItemLimit: 50,
    $counter: null,
    ean: null,
    url: null,
    antiforgeryToken: null,

    /**
     * Initializes the main panel detail if it exists.
     */
    init: function () {
        if (this.$mainPanel.length) {
            this.initMainPanelDetail();
        }
    },

    initMainPanelDetail: function () {
        this.mediaPanel = femcare.product.panel.media;
        this.ean = this.$mainPanel.attr('data-ean');
        this.url = this.$mainPanel.attr('data-product-url');
        this.sku = { skuId: this.$mainPanel.attr('data-initial-sku') };
        this.$productMedia = this.$mainPanel.find('.product-main__media-panel');

        this.$counter = this.$mainPanel.find('.counter');
        this.antiforgeryToken = femcare.product.cart.getAntiforgeryToken();

        this.mediaPanel.init();
        femcare.tooltip.init();
        this.initCounter();
        this.initAddToCart(false);
        this.initSkuOptions();
        // this.initAddToStash();
        this.initOutOfStockModal();
    },

    mainPanelSlim: function (product) {
        const $mainPanelSlim = product;
        this.mediaPanel = femcare.product.panel.media;
        this.ean = $mainPanelSlim.attr('data-ean');
        this.url = $mainPanelSlim.attr('data-product-url');
        this.sku = { skuId: $mainPanelSlim.attr('data-initial-sku') };
        this.$counter = $mainPanelSlim.find('.counter');
        this.antiforgeryToken = femcare.product.cart.getAntiforgeryToken();
        this.$productMedia = product.find('.product-main__media-panel');

        this.mediaPanel.init(product);
        femcare.tooltip.init();
        this.initCounter();
        this.initAddToCart(true);
        this.initSkuOptions();
        // this.initAddToStash();
    },

    initCounter: function () {
        this.$counter.counter({ max: parseInt(this.$counter.attr('data-max'), 10) });
    },

    initSkuOptions: function () {
        const $selectMenuWidgets = $('.product-main-options .form-group--product-radio-group');

        $selectMenuWidgets.each((index, element) => {
            const $select = $(element);
            this.selectedOptions[$select.attr('id')] = $select.find('input:checked').val();

            $select.find('input').on('change', (e) => {
                const selectedInput = e.target;
                this.selectedOptions[$select.attr('id')] = selectedInput.value;
                this.loadSku();
            });
        });
    },

    /**
     * Refreshes SKU information and updates various components based on the new SKU data.
     * @param {object} sku - The SKU object.
     * @param {object} res - The response object.
     */
    refreshSku: function (sku, res) {
        this.updateSkuName(sku.productSkuName);
        this.updateSkuPrice(sku.priceInformation);
        this.updateAddToCart(sku.productQuantity);
        this.updateSkuVariationOptions(sku);
        this.updateSkuOutOfStock(res);
        this.replaceSkuSlides(sku);
        this.mediaPanel.init();
    },

    /**
     * Updates the displayed SKU name.
     * @param {string} name - The SKU name.
     */
    updateSkuName: function (name) {
        $('.product-main__name').text(name);
    },

    /**
     * Updates the displayed SKU price information.
     * @param {object} price - The price information.
     */
    updateSkuPrice: function (price) {
        const $strikethroughPrice = $('.product-main-purchase__amount--old');
        const $price = $('.product-main-purchase__amount--new');

        if (price.showDiscount) {
            $strikethroughPrice.text(price.priceWithoutDiscount);
            $strikethroughPrice.show();
            $price.text(price.sellingPrice);
        } else {
            $strikethroughPrice.text('');
            $strikethroughPrice.hide();
            $price.text(price.priceWithoutDiscount);
        }
    },

    /**
     * Initializes "Add to Cart" functionality and sets up the event listener for the "Add to Cart" button.
     * @param {boolean} isSlimProduct - Indicates if the product is slim.
     */
    initAddToCart: function (isQuickBuy) {
        const $addToCart = $('.product-cart-add__button');

        $addToCart.on('click', () => {
            const count = this.$counter.counter('getCount');

            const data = {
                ean: this.ean,
                url: this.url,
                id: this.sku.skuId,
                variationAttributes: this.getVariationAttributes(),
                quantity: count
            };

            femcare.loader.toggleLoader(this.$notificationModal[0], true);

            $.ajax({
                url: femcare.shared.util.baseUrl + 'ajax/products/product/addItemToBag',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(data),
                headers: { 'X-Request-Verification-Token': this.antiforgeryToken },
                success: (res) => {
                    if (res.success) {
                        const contentData = typeof res.content === 'string' ? JSON.parse(res.content) : res.content;
                        const product = contentData.product;
                        const checkoutUrl = contentData.checkoutUrl;

                        femcare.loader.toggleLoader(this.$notificationModal[0], false);
                        this.refreshCartCount(this.antiforgeryToken);
                        femcare.product.cart.displayAddedNotification(product, checkoutUrl);
                        this.updateCartNotificationSuggestedProducts(res);
                        femcare.shared.rangeSlider.init();

                        // TODO Remove old GA events after GA4 transition
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'addToCart',
                            ecommerce: {
                                currencyCode: product.priceInformation.currency.code,
                                add: {
                                    products: [{
                                        name: product.productSkuNameComplete,
                                        id: product.productId,
                                        price: product.priceInformation.sellingPriceNoFormat,
                                        quantity: product.productQuantity.initial.toString(),
                                        category: product.category,
                                        variant: product.productSkuName
                                    }]
                                }
                            }
                        });

                        femcare.tracking.product.ecommAddProductToCart(product, count, isQuickBuy);

                        if (isQuickBuy) {
                            $('.modal--quick-buy').removeClass('displayed');
                        }
                    }
                },
                error: () => {
                    femcare.loader.toggleLoader(this.$notificationModal[0], false);
                }
            });
        });
    },

    /**
     * Executes a data layer event with the provided event and ecommerce data.
     * @param {string} event - The event to execute.
     * @param {object} ecommerce - The ecommerce data.
     */
    executeDatalayer: function (event, ecommerce) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(
            {
                event: event,
                ecommerce: ecommerce
            });
    },

    /**
     * Refreshes the displayed cart count and publishes a notification about the updated cart item count.
     * @param {String} protectionToken - antiforgery token
     */
    refreshCartCount: function (protectionToken) {
        femcare.loader.toggleLoader(this.$notificationModal[0], true);

        return $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/getbag?onlyTotal',
            dataType: 'json',
            method: 'GET',
            headers: { 'X-Request-Verification-Token': protectionToken },
            success: (res) => {
                const contentData = typeof res.content === 'string' ? JSON.parse(res.content) : res.content;
                const cartItemCount = (contentData && contentData.totalItems) || 0;
                femcare.shared.pubsub.publish('CART_ITEM_COUNT_UPDATED', cartItemCount);
            },
            complete: () => {
                femcare.loader.toggleLoader(this.$notificationModal[0], false);
            }
        });
    },

    /**
     * Updates the "Add to Cart" button based on the available quantity.
     * @param {object} quantity - The quantity information.
     */
    updateAddToCart: function (quantity) {
        const availableQuantity = parseInt(quantity.max, 10);
        $('.product-main--shop')
            .find('.product-unavailable__message--availability')
            .text(quantity.availability.stockMessage);

        if (availableQuantity > 0) {
            this.$counter.counter('setCount', 1);
            this.$counter.counter('setMax', Math.min(this.defaultShopItemLimit, availableQuantity));
            this.toggleOutOfStockMessage(false);
        } else {
            this.toggleOutOfStockMessage(true);
        }
    },

    /**
     * Toggles the visibility of the out-of-stock message.
     * @param {boolean} show - Indicates whether to show the message.
     */
    toggleOutOfStockMessage: function (show) {
        const $mainPanel = $('.product-main--shop');
        const $addButton = $mainPanel.find('.product-cart-add__button');
        const $counter = $mainPanel.find('.product-cart-add__counter');
        const $message = $mainPanel.find('.product-unavailable');
        const $stash = $mainPanel.find('.product-stash-add');

        if (show) {
            $addButton.hide();
            $counter.hide();
            $stash.hide();
            $message.show();
        } else {
            $addButton.show();
            $counter.show();
            $stash.show();
            $message.hide();
        }
    },

    /**
     * Loads and updates SKU information based on the selected options.
     */
    loadSku: function () {
        const data = {
            ean: this.ean,
            url: this.url,
            variationAttributes: this.getVariationAttributes()
        };

        femcare.loader.toggleLoader(this.$productMedia[0], true);

        $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/detailproductsku',
            method: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json',
            headers: { 'X-Request-Verification-Token': this.antiforgeryToken },
            success: (res) => {
                const contentData = typeof res.content === 'string' ? JSON.parse(res.content) : res.content;
                const product = contentData.product;

                if (product) {
                    this.sku = product;
                    this.refreshSku(this.sku, res);
                    this.updateOutOfStockTitle(product.productQuantity.availability);
                } else {
                    this.$mainPanel.find('.product-cart-add__counter').hide();
                    this.$mainPanel.find('.product-cart-add__button').hide();
                    this.$mainPanel.find('.product-main-options .form-group--product-radio-group input').each(function () {
                        $(this).removeAttr('disabled');
                    });
                }

                femcare.tracking.product.eccomViewProductVariantAnalytics(product);
            },
            complete: () => {
                femcare.loader.toggleLoader(this.$productMedia[0], false);
            }
        });
    },

    /**
     * Resets the selected options of the product object to an empty state.
     */
    resetSelectedOptions: function () {
        this.selectedOptions = {};
    },

    /**
     * Retrieves and returns an array of selected variation attributes.
     * @returns {Array} - The variation attributes array.
     */
    getVariationAttributes: function () {
        const variationAttributes = [];

        for (const key in this.selectedOptions) {
            if (this.selectedOptions.hasOwnProperty(key)) {
                variationAttributes.push({
                    name: key,
                    value: this.selectedOptions[key]
                });
            }
        }

        return variationAttributes;
    },

    /**
     * Replaces the existing SKU slides with new ones based on the provided SKU data.
     * @param {object} sku - The SKU object.
     */
    replaceSkuSlides: function (sku) {
        const $mainSlides = $('.product-main__slides');
        const $thumbnailSlides = $('.product-main__thumbnails');
        const zoomInAsset = $mainSlides.attr('data-zoom-in');
        const zoomOutAsset = $mainSlides.attr('data-zoom-out');

        this.mediaPanel.thumbnailGallery && this.mediaPanel.thumbnailGallery.destroy();
        this.mediaPanel.thumbnailGallery = null;
        this.mediaPanel.mainGallery && this.mediaPanel.mainGallery.destroy();
        this.mediaPanel.mainGallery = null;

        const $tempMainSlideContainer = $('<div></div>');
        const $tempThumbnailContainer = $('<div></div>');

        sku.images.forEach(function (image) {
            const $mainSlide = $('<div class="product-main__slide swiper-slide"></div>');
            const $zoomContainer = $('<div class="swiper-zoom-container"></div>');
            const $zoomTarget = $('<div class="swiper-zoom-target"></div>');

            const $standardImageWrapper = $('<div class="product-main__image product-main__image--standard"></div>');
            $standardImageWrapper.css('cursor', 'url(' + zoomInAsset + ') 17.5 17.5, pointer');
            const $standardImage = $('<img loading="lazy"/>');
            $standardImage.attr('src', image.url);
            $standardImageWrapper.append($standardImage);
            $zoomTarget.append($standardImageWrapper);

            const $largeImageWrapper = $('<div class="product-main__image product-main__image--large"></div>');
            $largeImageWrapper.css('cursor', 'url(' + zoomOutAsset + ') 17.5 17.5, pointer');
            const $largeImage = $('<img loading="lazy"/>');
            $largeImage.attr('src', image.url);
            $largeImageWrapper.append($largeImage);
            $zoomTarget.append($largeImageWrapper);

            $zoomContainer.append($zoomTarget);
            $mainSlide.append($zoomContainer);
            $tempMainSlideContainer.append($mainSlide);

            const $thumbnailSlide = $('<li class="product-main__thumbnail swiper-slide"></li>');
            const $thumbnailImage = $('<img src="' + image.url + '"/>');
            $thumbnailSlide.append($thumbnailImage);
            $tempThumbnailContainer.append($thumbnailSlide);
        });

        $mainSlides
            .empty()
            .append($tempMainSlideContainer.html());

        $thumbnailSlides
            .empty()
            .append($tempThumbnailContainer.html());
    },

    /**
     * Initializes the out-of-stock modal and sets up event listeners for the modal interaction.
     */
    initOutOfStockModal: function () {
        const $modal = $('#outOfStockModal');
        const $notificationForm = $modal.find('.product-unavailable__form');
        const $modalTitle = $modal.find('.modal__title');
        const $modalBody = $modal.find('.modal__body');

        // Store original title and body so we can restore them later
        const originalTitle = $modalTitle.text();
        const originalBody = $modalBody.html();

        $notificationForm.on('submit', (e) => {
            e.preventDefault();

            const formData = new FormData($notificationForm[0]);
            const postData = {};

            formData.forEach(function (value, key) {
                postData[key] = value;
            });

            postData.ean = this.ean;
            postData.url = this.url;
            postData.variationAttributes = this.getVariationAttributes();

            axios.post(
                femcare.shared.util.baseUrl + 'ajax/products/product/notifyMe',
                postData,
                {
                    headers: {
                        'X-Request-Verification-Token': this.antiforgeryToken,
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }
            )
                .then((res) => {
                    if (res.data && res.data.success) {
                        // Update title and body content with response and remove submit button
                        $modalTitle.text(res.data.heading);
                        $modalBody.html(res.data.body);
                        $notificationForm.find('button[type="submit"]').remove();
                    }
                })
                .catch((err) => {
                    console.error('Notify me request failed', err);
                });
        });

        // Restore modal content when it's closed
        $modal.on('transitionend', (e) => {
            if (!$modal.hasClass('displayed')) {
                $modalTitle.text(originalTitle);
                $modalBody.html(originalBody);
            }
        });
    },

    /**
     * Updates the SKU variation options based on the provided SKU data.
     * @param {object} sku - The SKU object.
     */
    updateSkuVariationOptions: function (sku) {
        if (!sku.optionGroups) {
            return;
        }

        sku.optionGroups.forEach(function (optGroup) {
            optGroup.values.forEach(function (optValue) {
                const option = $('.form-group--product-radio-group[id="' + optGroup.label + '"] input[value="' + optValue.value + '"]');
                option.removeAttr('disabled');
                option.removeAttr('checked');
                if (optValue.selected) {
                    option.prop('checked', true);
                }
                if (optValue.disabled) {
                    option.prop('disabled', true);
                }
            })
        })
    },

    /**
     * Updates SKU out-of-stock information and renders suggested products if available.
     * @param {object} res - The response object.
     */
    updateSkuOutOfStock: function (res) {
        if (res.suggestedProductsRendered) {
            window.pr_render_options_sp = [];

            $('.suggested-products__slider').replaceWith(res.suggestedProductsRendered);
            femcare.product.panel.info.slider.init();
            this.renderPowerReviews();
        }
    },

    /**
     * Updates the text of the out-of-stock title based on the provided availability information.
     * @param {Object} availability - The availability object containing stock information.
     */
    updateOutOfStockTitle: function (availability) {
        let $outOfStockTitle = $('.product-main__out-of-stock--title');

        if (availability && availability.itemAvailability === 'OutOfStock' && availability.stockMessage) {
            $outOfStockTitle.text(availability.stockMessage);
        } else {
            $outOfStockTitle.text('');
        }
    },

    /**
     * Updates suggested products in the cart notification area based on the provided response.
     * @param {object} res - The response object.
     */
    updateCartNotificationSuggestedProducts: function (res) {
        if (res.suggestedProductsRendered) {
            window.pr_render_options_sp = [];

            $('.cart-suggested').replaceWith(res.suggestedProductsRendered);
            this.renderPowerReviews();
        }
    },

    /**
     * Renders PowerReviews if the library is loaded.
     */
    renderPowerReviews: function () {
        const isPowerReviewsLoaded = window.POWERREVIEWS;
        if (isPowerReviewsLoaded) {
            const pr_render_options_sp = window.pr_render_options_sp || [];
            window.POWERREVIEWS.display.render(pr_render_options_sp);
        }
    }
};
